import request from '../utils/http'
// 列表（角色）
export function index (query) {
  return request({
    url: '/accountRole/index',
    method: 'GET',
    params: query
  })
}
// 详情
export function edit (query) {
  return request({
    url: '/accountRole/edit',
    method: 'GET',
    params: query
  })
}
// 新增
export function save (query) {
  return request({
    url: '/accountRole/save',
    method: 'POST',
    data: query
  })
}
// 更新
export function update (query) {
  return request({
    url: '/accountRole/update',
    method: 'POST',
    data: query
  })
}
// 开关
export function show (query) {
  return request({
    url: '/accountRole/show',
    method: 'POST',
    data: query
  })
}
// 删除
export function del (query) {
  return request({
    url: '/accountRole/delete',
    method: 'DELETE',
    data: query
  })
}
// 权限节点
export function nodeIndex (query) {
  return request({
    url: '/accountRole/nodeIndex',
    method: 'GET',
    params: query
  })
}
// 机构
export function mechanism (query) {
  return request({
    url: '/mechanism/list?limit=500',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/accountRole.js